import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../shared/services/auth/auth.service';
import { BodyClassService } from '../shared/services/body-class.service';
import * as moment from 'moment';

import { URL_CONTACT_US, URL_PRIVACY_STATEMENT } from '../shared/browser/url-collections';

@Component({
  selector: 'access',
  template: `
    <div style="display: inline" *ngIf="!autoAuthenticating">
      <div class="container access">
        <div class="logo"></div>
        <div class="access-content" ui-view=""></div>
      </div>
      <div class="footer">
        <div class="text-muted row g-0">
          <p class="version col">ACSL GA GA2-2.0.23716-16858</p>
          <p class="menu-footer col-auto pe-0">
            <a [href]="privacyStatementUrl" target="_blank" [attr.title]="('GA.GENERAL.PRIVACY_STATEMENT' | translate)" translate>GA.GENERAL.PRIVACY_STATEMENT</a>
            <a [href]="contactUsUrl" [attr.title]="('GA.GENERAL.CONTACT_US' | translate)" translate>GA.GENERAL.CONTACT_US</a>
          </p>
          <p class="copy col-auto ps-0">Copyright &copy; {{year}}, ACSL</p>
        </div>
      </div>
    </div>
  `
})
export class AccessComponent implements OnInit, OnDestroy {
  public year:number;
  public privacyStatementUrl:string;
  public contactUsUrl:string;

  constructor(
    private authService:AuthService,
    private bodyClassService:BodyClassService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.year = moment().year();
    this.bodyClassService.add('has-footer');
    this.contactUsUrl = URL_CONTACT_US;
    this.privacyStatementUrl = URL_PRIVACY_STATEMENT;
  }

  public ngOnDestroy():void {
    this.bodyClassService.remove('has-footer');
  }

  public get autoAuthenticating():boolean {
    return this.authService.autoAuthenticating;
  }
}